import React, { useState } from 'react';
import { Container, Typography, Paper, Box, Grid, Card, CardContent, TextField, Button, Alert } from '@mui/material';
import { 
  Email, 
  LocationOn, 
  Schedule, 
  QuestionAnswer, 
  BugReport, 
  Send,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon 
} from '@mui/icons-material';
import TikTokIcon from '@mui/icons-material/MusicVideo'; // Using MusicVideo as a substitute for TikTok

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link with form data
    const mailtoLink = `mailto:nechcilepek@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Jméno: ${formData.name}\nEmail: ${formData.email}\n\nZpráva:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 5000);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper 
        elevation={8}
        sx={{ 
          borderRadius: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
          border: '1px solid rgba(0,0,0,0.1)',
          p: { xs: 4, sm: 6 }
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ 
            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 50%, #e55039 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 800,
            textAlign: 'center',
            mb: 4
          }}
        >
          Kontaktujte nás
        </Typography>
        
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.6, mb: 4, textAlign: 'center' }}>
          Máte otázky ohledně aplikace Nechci Lepek? Rádi vám pomůžeme! Kontaktujte nás prostřednictvím 
          níže uvedených možností a my se vám ozveme co nejdříve.
        </Typography>

        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
              <CardContent>
                <Email sx={{ fontSize: 48, color: '#ff6b6b', mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Email
                </Typography>
                <Typography paragraph sx={{ color: '#666' }}>
                  Pro obecné dotazy a technickou podporu
                </Typography>
                <Typography sx={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                  nechcilepek@gmail.com
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
              <CardContent>
                <Schedule sx={{ fontSize: 48, color: '#ff6b6b', mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Doba odezvy
                </Typography>
                <Typography paragraph sx={{ color: '#666' }}>
                  Standardní doba odpovědi
                </Typography>
                <Typography sx={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                  24-48 hodin
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Social Media Section */}
          <Grid item xs={12}>
            <Card sx={{ 
              height: '100%', 
              textAlign: 'center', 
              p: 2,
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
            }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
                  Sledujte nás na sociálních sítích
                </Typography>
                <Typography paragraph sx={{ color: '#666', mb: 3 }}>
                  Buďte součástí naší bezlepkové komunity a získejte nejnovější informace a tipy
                </Typography>
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  gap: 3,
                  flexWrap: 'wrap'
                }}>
                  <Button
                    href="https://www.facebook.com/nechcilepek"
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<FacebookIcon />}
                    sx={{
                      color: '#fff',
                      backgroundColor: '#1877f2',
                      borderRadius: 2,
                      px: 3,
                      '&:hover': {
                        backgroundColor: '#166fe5',
                        transform: 'translateY(-2px)',
                        transition: 'all 0.2s'
                      }
                    }}
                  >
                    Facebook
                  </Button>
                  <Button
                    href="https://www.instagram.com/nechcilepek/"
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<InstagramIcon />}
                    sx={{
                      color: '#fff',
                      background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                      borderRadius: 2,
                      px: 3,
                      '&:hover': {
                        background: 'linear-gradient(45deg, #e88a2e 0%, #d85f37 25%, #cc233d 50%, #bb205d 75%, #ab167c 100%)',
                        transform: 'translateY(-2px)',
                        transition: 'all 0.2s'
                      }
                    }}
                  >
                    Instagram
                  </Button>
                  <Button
                    href="https://www.tiktok.com/@nechcilepek"
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<TikTokIcon />}
                    sx={{
                      color: '#fff',
                      backgroundColor: '#000',
                      borderRadius: 2,
                      px: 3,
                      '&:hover': {
                        backgroundColor: '#333',
                        transform: 'translateY(-2px)',
                        transition: 'all 0.2s'
                      }
                    }}
                  >
                    TikTok
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Contact Form */}
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mb: 3 }}>
            Kontaktní formulář
          </Typography>
          
          {showSuccess && (
            <Alert severity="success" sx={{ mb: 3 }}>
              Váš emailový klient by měl být nyní otevřený s předvyplněnou zprávou. Pokud se tak nestalo, 
              napište nám přímo na nechcilepek@gmail.com
            </Alert>
          )}

          <Paper sx={{ p: 3 }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Vaše jméno"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Váš email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Předmět"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Vaše zpráva"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    multiline
                    rows={6}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    startIcon={<Send />}
                    sx={{
                      background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
                      px: 4,
                      py: 1.5,
                      fontSize: '1rem',
                      fontWeight: 'bold',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #ff5252 0%, #e53e3e 100%)',
                      }
                    }}
                  >
                    Odeslat zprávu
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Box>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 3 }}>
          Typy dotazů
        </Typography>

        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
              <CardContent>
                <QuestionAnswer sx={{ fontSize: 40, color: '#4caf50', mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Obecné dotazy
                </Typography>
                <Typography paragraph sx={{ fontSize: '0.9rem' }}>
                  Otázky o funkcionalitě aplikace, bezlepkové dietě a použití služby
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
              <CardContent>
                <BugReport sx={{ fontSize: 40, color: '#ff9800', mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Technické problémy
                </Typography>
                <Typography paragraph sx={{ fontSize: '0.9rem' }}>
                  Nahlášení chyb, problémů s aplikací nebo návrhy na vylepšení
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          
          <Grid item xs={12} md={12} lg={12}>
            <Card sx={{ height: '100%', textAlign: 'center', p: 2 }}>
              <CardContent>
                <LocationOn sx={{ fontSize: 40, color: '#2196f3', mb: 2 }} />
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Chybějící produkty
                </Typography>
                <Typography paragraph sx={{ fontSize: '0.9rem' }}>
                  Informování o produktech, které nejsou v naší databázi
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Často kladené dotazy
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Před kontaktováním si prosím prostudujte naši sekci často kladených otázek na hlavní stránce. 
          Mnoho běžných dotazů již může být zodpovězeno. To vám ušetří čas a umožní nám se soustředit 
          na specifičtější problémy.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Zpětná vazba
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Vaše zpětná vazba je pro nás neocenitelná. Pomáhá nám vylepšovat aplikaci a přidávat nové funkce, 
          které skutečně potřebujete. Neváhejte nám poslat své návrhy, připomínky nebo zkušenosti s používáním 
          aplikace Nechci Lepek.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Partnerství a spolupráce
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Pokud jste výrobce bezlepkových produktů, obchodník nebo zdravotnické zařízení a máte zájem 
          o spolupráci, kontaktujte nás. Rádi projednáme možnosti partnerství a způsoby, jak můžeme 
          společně pomoci bezlepkové komunitě.
        </Typography>

        <Box sx={{ mt: 4, p: 3, bgcolor: '#fff3e0', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#e65100', fontWeight: 600 }}>
            Důležité upozornění
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.6 }}>
            Aplikace Nechci Lepek neposkytuje lékařské poradenství. Pro zdravotní otázky související 
            s celiaklií nebo glutenovou senzitivitou se prosím obraťte na kvalifikovaného zdravotnického 
            pracovníka nebo nutričního specialistu.
          </Typography>
        </Box>

        <Box sx={{ mt: 4, p: 3, bgcolor: '#f5f5f5', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#333', fontWeight: 600 }}>
            Ochrana osobních údajů
          </Typography>
          <Typography paragraph sx={{ lineHeight: 1.6 }}>
            Při kontaktování nás respektujeme vaše soukromí a zacházíme s vašimi osobními údaji 
            v souladu s našimi zásadami ochrany osobních údajů. Vaše email a další kontaktní 
            informace používáme výhradně pro odpověď na váš dotaz.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ContactUs; 